import { type UseQueryResult, useQuery } from 'react-query';
import {
  BlackoutService,
  // eslint-disable-next-line camelcase
  type Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_CustomerService_Dtos_Blackout_BlackoutListDTO_Wealthlane_CustomerService_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null,
} from '../../services/wealthlane-customer-services';
import { type TableParamsType } from '../../types/common';

const useGetTradingBlackoutConfigList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_CustomerService_Dtos_Blackout_BlackoutListDTO_Wealthlane_CustomerService_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null
  | undefined,
  unknown
> => {
  const { eligibleIds, fromDate, toDate, filter, sorting, skipCount, maxResultCount } = tableInfo;
  const tradingBlackoutConfig = useQuery(
    [
      'getTradingBlackoutConfigList',
      eligibleIds,
      fromDate,
      toDate,
      filter,
      sorting,
      skipCount,
      maxResultCount,
    ],
    async () => {
      const tradingBlackoutConfigList = await handleRequest(
        BlackoutService.getApiCustomerApiAppBlackoutBlackoutList(
          eligibleIds,
          fromDate,
          toDate,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );

      return tradingBlackoutConfigList;
    }
  );
  return tradingBlackoutConfig;
};

export default useGetTradingBlackoutConfigList;
